import React from 'react'
import ReactOnRails from 'react-on-rails'
import { AppContext } from '~/context/appContext'
import RequestNewPaymentMethodModal from '~/organisms/Billing/RequestNewPaymentMethodModal'
import '~/tailwind-output.css'

const RequestNewPaymentMethodRoot = ({ companyId, jwt, balanceDue, autoRenew, openInvoices }) => {
  const csrf = ReactOnRails.authenticityToken()

  return (
    <AppContext.Provider value={{ company: { id: companyId }, jwt, csrf }}>
      <RequestNewPaymentMethodModal balanceDue={balanceDue} autoRenew={autoRenew} openInvoices={openInvoices} />
    </AppContext.Provider>
  )
}

export default RequestNewPaymentMethodRoot
